import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const negatives = ['This is not a random collection of Judo drills.', 'This is not a generic martial arts manual full of theory that you still need to turn into a real session.', 'This is not an app or a video course.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-[#081632] relative overflow-hidden" data-id="element-231" data-mp="1mt1vo6sv6z3s">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-[#D89B16]/60" data-id="element-232" data-mp="z1whrx6higw4" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-233" data-mp="u3urosan5hb5">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-234" data-mp="182kmg19zn4wc">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/10 text-[#D89B16] mb-5" data-id="element-235" data-mp="2jg6mwilassx6">
            <span className="text-2xl" data-id="element-236" data-mp="2ffcxtlw4d82p">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-white" data-id="element-237" data-mp="2bwiayyyhm489">
            The complete Judo coaching system for coaches worldwide
          </h2>
          <h3 className="text-xl font-bold text-[#D89B16] mb-3" data-id="element-238" data-mp="2kwdr7i6wgpf5">JUDO COACH READY</h3>
          <p className="text-base md:text-lg text-white font-semibold mb-1" data-id="element-239" data-mp="2kukjdzkjvz5k">
            A complete 6-in-1 visual coaching system
          </p>
          <p className="text-base md:text-lg text-white/80 mb-10" data-id="element-240" data-mp="1t60o3b0c62ut">
            6 Complete Volumes • 150 Ready-to-Coach Sessions • 5 Professional Bonus Guides
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-241" data-mp="225nopul8r4mt">
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-white/5 p-6 rounded-2xl border border-white/15" data-id="element-242" data-mp="2242s7zfd9bmb">
            {negatives.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-243" data-mp="2hpxokyhxjyr9">
                <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-244" data-mp="2csxlmwgdnc4d" />
                <p className="text-white/70 text-sm" data-id="element-245" data-mp="2qjj4wm9qto2s">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white p-6 rounded-2xl border border-[#D89B16]" data-id="element-246" data-mp="2mhfjb4td133s">
            <div className="flex items-start gap-3" data-id="element-247" data-mp="27tb6ghgznlsx">
              <Check className="text-[#D89B16] shrink-0 mt-1" size={20} data-id="element-248" data-mp="27qoodnwh1nwg" />
              <p className="text-[#081632] font-medium text-base leading-relaxed" data-id="element-249" data-mp="22seudgmhgtcf">
                Judo Coach Ready is a complete visual PDF-based coaching system created to help
                coaches plan less, teach with more structure, correct technique more clearly and
                develop better judoka.
              </p>
            </div>
            <p className="text-[#1E4ED8] font-bold text-sm mt-4 pl-8" data-id="element-250" data-mp="3qrhac04g71wq">
              Open the system. Choose the objective. Select the session. Coach.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}